import {Component, Input, ViewEncapsulation} from '@angular/core';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { Lightbox, LightboxModule } from 'ng-gallery/lightbox';
import { GalleryItem, Gallery, ImageItem, ImageSize, ThumbnailsPosition } from 'ng-gallery';

@Component({
  selector: 'app-events-evidence-files',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './events-evidence-files.component.html',
  styleUrl: './events-evidence-files.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class EventsEvidenceFilesComponent {
  @Input() list: string;
  @Input() close!: () => void;
  imgData: any[] = [];
  private items: GalleryItem[];

  constructor(public modalFiles: NgbModal, public gallery: Gallery, public lightbox: Lightbox){

  }

  ngOnInit() {
    this.imgData = this.list.split(',').map(item => {
      const isPdf = item.trim().toLowerCase().endsWith('.pdf');
      const thumb = isPdf ? 'assets/img/events/icon-pdf.png' : item.trim();
      return { srcUrl: item.trim(), previewUrl: thumb };
    });
    this.items = this.list.split(',').map((item: any) => new ImageItem({ src: item.srcUrl, thumb: item.previewUrl }));
    const lightboxRef = this.gallery.ref('lightbox');
    lightboxRef.setConfig({
      imageSize: ImageSize.Cover,
      thumbPosition: ThumbnailsPosition.Top
    });
    lightboxRef.load(this.items);
  }

}
